import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { login, editProfile, changePassword, completeProfile, resendNewOtp, otpVerification, forgetPassword, setPassword, languageListing, turnOnOffNotification, checkUserExist, buyCourseApp } from "../api/apiHandler";
import {
    getLanguageDataFromLocal,
    getLocalStorageItem,
    getToken,
    getUserDataFromLocal,
    removeUserDataFromLocal,
    saveUserDataToLocal,
    setLocalStorageItem,
} from "../common/LocalStorageService";
import { signup } from "../api/apiHandler";
import { fetchCartData } from "./cartPaymentSlice";

export const signupUser = createAsyncThunk(
    "auth/signupUser",
    async ({ payload }, { rejectWithValue }) => {
        try {

            const response = await signup(payload);

            if (response?.code === 200) {
                const language = getLocalStorageItem("language");
                if (language) {
                    response.data.language_id = language.lang_id;
                    response.data.lang_code = language.lang_code;
                }
                else {
                    response.data.language_id = 1;
                    response.data.lang_code = "en";
                }
                saveUserDataToLocal(response.data);
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response.data);
        }
    }
);

export const loginUser = createAsyncThunk(
    "auth/loginUser",
    async ({ payload }, { rejectWithValue, dispatch }) => {
        try {
            const response = await login(payload);

            if (response?.code === 200) {
                const lang = await languageListing({ id: response.data.language_id })
                if (lang.code === 200) {
                    response.data.lang_code = lang.data.code
                }
                else {
                    response.data.lang_code = 'en'
                }
                saveUserDataToLocal(response.data);
                dispatch(fetchCartData());
                return response;
            } 
            else if (response?.code == 404) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response);
        }
    }
);

export const updateProfile = createAsyncThunk(
    "auth/editProfile",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await editProfile(payload);
            if (response?.code === 200) {
                const lang = await languageListing({ id: response.data.language_id })
                if (lang.code === 200) {
                    response.data.lang_code = lang.data.code
                    response.data.name = lang.data.name
                }
                else {
                    response.data.lang_code = 'en'
                    response.data.name = "english"
                }
                saveUserDataToLocal(response.data);
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response);
        }
    }
);

export const updatePassword = createAsyncThunk(
    "auth/changePassword",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await changePassword(payload);
            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response);
        }
    }
);

export const completeUserProfile = createAsyncThunk(
    "auth/completeProfile",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await completeProfile(payload);
            if (response?.code === 200) {
                saveUserDataToLocal(response.data);
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response);
        }
    }
);

export const resendOtp = createAsyncThunk(
    "auth/resendOtp",
    async ({ payload }, { rejectWithValue }) => {
        try {

            const response = await resendNewOtp(payload);

            if (response?.code === 200) {

                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response.data);
        }
    }
);

export const otpVerify = createAsyncThunk(
    "auth/otpVerification",
    async ({ payload }, { rejectWithValue }) => {
        try {

            const response = await otpVerification(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response.data);
        }
    }
);

export const forgotPassword = createAsyncThunk(
    "auth/forgetPassword",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await forgetPassword(payload);
            if (response?.code === 200 || response?.code === 400 || response?.code == 401) {
                return response;
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response);
        }
    }
)

export const setNewPassword = createAsyncThunk(
    "auth/setNewPassword",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await setPassword(payload);
            if (response?.code === 200) {
                return response;
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response);
        }
    }
)

export const onOffNotification = createAsyncThunk(
    "auth/onOffNotification",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await turnOnOffNotification(payload);
            if (response?.code === 200) {
                return response;
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response);
        }
    }
)

export const checkUniqueUser = createAsyncThunk(
    "auth/checkUnique",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await checkUserExist(payload);
            if (response?.code === 200 || response?.code === 400) {
                return response;
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response);
        }
    }
)

export const buyCourseApplication = createAsyncThunk(
    "auth/buyCourseApp",
    async (payload, { rejectWithValue, dispatch }) => {
        try {
            const response = await buyCourseApp(payload);
            if (response?.code === 200 || response?.code === 400) {
                saveUserDataToLocal(response.data);
                dispatch(fetchCartData());
                return response;
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response);
        }
    }
)

const userToken = getToken();

const initialState = {
    loading: false,
    userInfo: getUserDataFromLocal(),
    userToken,
    language: getLanguageDataFromLocal(),
    error: null,
    success: false,
};

const authSlice = createSlice({
    name: "auth",
    initialState,

    reducers: {
        logout: (state) => {
            removeUserDataFromLocal();
            state.loading = false;
            state.userInfo = null;
            state.userToken = null;
            state.language = null;
            state.error = null;
        },
        deleteUserProfile: (state) => {
            removeUserDataFromLocal();
            state.loading = false;
            state.userInfo = null;
            state.userToken = null;
            state.language = null;
            state.error = null;
        },
        setUserInfo: (state, action) => {
            saveUserDataToLocal(action.payload);
            state.loading = false;
            state.userInfo = action.payload;
            state.userToken = null;
            state.language = null;
            state.error = null;
        },
        setLangCode: (state, action) => {
            state.userInfo.lang_code = action.payload.lang_code;
            saveUserDataToLocal(state.userInfo);
        },
        setLanguage: (state, action) => {
            state.language = {
                lang_id: action.payload.lang_id,
                lang_code: action.payload.lang_code,
                name: action.payload.name,
            }
            setLocalStorageItem("language", action.payload);
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(loginUser.pending, (state) => {
                state.loading = true;
            })
            .addCase(loginUser.fulfilled, (state, { payload }) => {
                if (payload.code == 404) {
                    state.loading = false;
                }
                else {
                    state.loading = false;
                    state.userInfo = payload.data;
                    state.userToken = payload.data.user_device_info.token;
                    state.userInfo.lang_code = payload.data.user_language.code;
                    state.userInfo.language_id = payload.data.user_language.id;
                    state.userInfo.name = payload.data.user_language.name;
                    const newLanguage = {
                        lang_id: payload.data.user_language.id,
                        lang_code: payload.data.user_language.code,
                        name: payload.data.user_language.name,
                    };
                    setLocalStorageItem("language", newLanguage);
                }
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(signupUser.pending, (state) => {
                state.loading = true;
            })
            .addCase(signupUser.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.userInfo = payload.data;
                state.userToken = payload.data.user_device_info.token;
            })
            .addCase(signupUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(updateProfile.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateProfile.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.userInfo = payload.data;
                state.userToken = payload.data.user_device_info.token;
                state.userInfo.lang_code = payload.data.user_language.code;
                state.userInfo.language_id = payload.data.user_language.id;
                state.userInfo.name = payload.data.user_language.name;
                const newLanguage = {
                    lang_id: payload.data.user_language.id,
                    lang_code: payload.data.user_language.code,
                    name: payload.data.user_language.name,
                };
                setLocalStorageItem("language", newLanguage);
            })
            .addCase(updateProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(completeUserProfile.pending, (state) => {
                state.loading = true;
            })
            .addCase(completeUserProfile.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.userInfo = payload.data;
                state.userToken = payload.data.user_device_info.token;
            })
            .addCase(completeUserProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(forgotPassword.pending, (state) => {
                state.loading = true;
            })
            .addCase(forgotPassword.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.userInfo = payload.data;
            })
            .addCase(forgotPassword.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(onOffNotification.pending, (state) => {
                state.loading = true;
            })
            .addCase(onOffNotification.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.userInfo.is_notify = payload?.data?.is_notify;
            })
            .addCase(onOffNotification.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(checkUniqueUser.pending, (state) => {
                state.loading = true;
            })
            .addCase(checkUniqueUser.fulfilled, (state, { payload }) => {
                state.loading = false;
            })
            .addCase(checkUniqueUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            }).addCase(buyCourseApplication.pending, (state) => {
                state.loading = true;
            })
            .addCase(buyCourseApplication.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.userInfo = payload.data;
                state.userToken = payload.data.user_device_info.token;
                state.userInfo.lang_code = payload.data.user_language.code;
                state.userInfo.language_id = payload.data.user_language.id;
                state.userInfo.name = payload.data.user_language.name;
                const newLanguage = {
                    lang_id: payload.data.user_language.id,
                    lang_code: payload.data.user_language.code,
                    name: payload.data.user_language.name,
                };
                setLocalStorageItem("language", newLanguage);
            })
            .addCase(buyCourseApplication.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export const { logout, setUserInfo, setLangCode, setLanguage } = authSlice.actions;

export const { deleteUserProfile } = authSlice.actions;

export default authSlice.reducer;